import { render, staticRenderFns } from "./GuppyAudioMessage.vue?vue&type=template&id=1a67136f&scoped=true&"
import script from "./GuppyAudioMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyAudioMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyAudioMessage.vue?vue&type=style&index=0&id=1a67136f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a67136f",
  null
  
)

export default component.exports